/**
 * Import required libraries
 */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { labelFromPath } from "Utils";

/**
 * Import required elements
 */
// Material-ui components
import { Typography, Divider } from "@material-ui/core";

import { Warning as ErrorIcon } from "@material-ui/icons";

import styles from "./styles";

function parseDateTime(dt) {
  const [time, date] = dt.split(" ");
  const [day, month, year] = date.split("/");
  const [hour, min, sec] = time.split(":");
  return { day, month, year, hour, min, sec };
}

function Item(props) {
  const classes = styles({ type: props.msg.type });
  //console.log("item props :", props)
  return (
    <div className={classes.item}>
      <Typography className={classes.date} variant="caption">
        {props.date}
      </Typography>
      <div className={classes.itemFlex}>
        {props.msg.type === "error" ?
          <ErrorIcon className={classes.errorIcon} /> : null
        }
        <div>
          <Typography className={classes.message}>
            keyword : {JSON.stringify(props.msg.value[0].keyword)}
          </Typography>
          <Typography className={classes.message}>
            message : {JSON.stringify(props.msg.value[0].message)}
          </Typography>
          <Typography className={classes.message}>
            params : {JSON.stringify(props.msg.value[0].params)}
          </Typography>
        </div>
      </div>
    </div>
  );
}

/**
 * Notifications Component
 */
const Notifications = ({ lang, labelPath, notifications = [] }) => {
  labelPath += ".notifications";
  const _label = key => labelFromPath(labelPath, key, lang);

  // console.log("notif: ",notifications)
  useEffect(() => {
    notifications.sort((a, b) => {
      const dtA = parseDateTime(a.date);
      const dtB = parseDateTime(b.date);
      return (
        dtA.year < dtB.year ||
        dtA.month < dtB.month ||
        dtA.day < dtB.day ||
        dtA.hour < dtB.hour ||
        dtA.min < dtB.min ||
        dtA.sec < dtB.sec
      );
    });
  }, [notifications]);

  // CSS classnames
  const classes = styles();
  return (
    <div className={classes.container}>
      <div className={classes.Content}>
        {notifications.length > 0 ? notifications.flatMap((item, index, arr) => {
          let cont = [<Item {...item} key={item.date} />];
          if (index < arr.length - 1) cont.push(
            <Divider key={"divider_" + index} className={classes.divider} />
          );
          // console.log("cont :", cont)
          return cont //<div>{index}</div>;
        }) : (
          <Typography
            style={{ textAlign: "center", marginTop: "15px" }}
            color="textSecondary"
          >
            {_label("empty")}
          </Typography>
        )}
      </div>
    </div>
  );
};

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang,
  notifications: [...state.simtopy.notifications]
}))(Notifications);
